import * as React from 'react';

import { RepresentativeBadge } from '../../../../components/Commercial/RepresentativeBadge';
import { useOfferContext } from '../../../../context';
import { isRepresentative } from '../../../../utils/computedProps/commercial/isRepresentative';

export function RepresentativeBadgeContainer() {
  const { offer } = useOfferContext();

  if (!isRepresentative(offer)) {
    return null;
  }

  return <RepresentativeBadge />;
}

RepresentativeBadgeContainer.displayName = 'RepresentativeBadgeContainer';
